import { render, staticRenderFns } from "./DefinitionDetails.vue?vue&type=template&id=3063e4a5&"
import script from "./DefinitionDetails.vue?vue&type=script&lang=ts&"
export * from "./DefinitionDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports